import React from 'react'
import ProductsShortsLower from './ProductsShortsLower'
import ProductsJeansPant from './ProductsJeansPant'


export default function JeansPants() {
  return (
    <div>
        <ProductsJeansPant/>
    </div>
  )
}
